import { scanPiecePrice } from '@/lib/scanQuantity';
import { ScanMoneyInput } from '@/components/ScanMoneyInput';

export const ScanUnitPriceInput = ({ item, onChange, onValidityChange }) => {
  const id = item._key;
  const value = Number(scanPiecePrice(item).toFixed(8));
  const unit = item.eenheid_label && !['st', 'stuks'].includes(item.eenheid_label.toLowerCase()) ? item.eenheid_label : 'stuk';
  return <div className="min-w-0">
    <label htmlFor={`scan-unit-price-${id}`} className="block xl:sr-only text-[11px] font-bold text-black uppercase mb-1"
      data-testid={`scan-label-unit-price-${id}`}>Eenheidsprijs</label>
    <ScanMoneyInput value={value} onChange={onChange} testId={`scan-unit-price-${id}`}
      label={`Eenheidsprijs per ${unit}`} validationKey={`price-${id}`} onValidityChange={onValidityChange} />
    <span className="block text-[11px] text-gray-500 mt-1 break-words" data-testid={`scan-price-unit-${id}`}>€ / {unit}</span>
  </div>;
};